/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  IntegrationTestingConfigurationCreateDataRequest
} from '../../model/integrationTestingConfigurationCreateDataRequest'
import type {
  IntegrationTestingConfigurationEditDataRequest
} from '../../model/integrationTestingConfigurationEditDataRequest'
import type {
  IntegrationTestingConfigurationReadData
} from '../../model/integrationTestingConfigurationReadData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Create an integration testing configuration
 */
export const internalIntegrationTestingConfigurationCreate = (
    integrationTestingConfigurationCreateDataRequest: IntegrationTestingConfigurationCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<IntegrationTestingConfigurationReadData>(
      {url: `/integration-testing-configuration/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: integrationTestingConfigurationCreateDataRequest
    },
      options);
    }
  


export const getInternalIntegrationTestingConfigurationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationCreate>>, TError,{data: IntegrationTestingConfigurationCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationCreate>>, TError,{data: IntegrationTestingConfigurationCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationCreate>>, {data: IntegrationTestingConfigurationCreateDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  internalIntegrationTestingConfigurationCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalIntegrationTestingConfigurationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationCreate>>>
    export type InternalIntegrationTestingConfigurationCreateMutationBody = IntegrationTestingConfigurationCreateDataRequest
    export type InternalIntegrationTestingConfigurationCreateMutationError = unknown

    export const useInternalIntegrationTestingConfigurationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationCreate>>, TError,{data: IntegrationTestingConfigurationCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalIntegrationTestingConfigurationCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets a specific integration testing configuration.
 */
export const internalIntegrationTestingConfigurationRetrieve = (
    integrationTestingConfigurationId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<IntegrationTestingConfigurationReadData>(
      {url: `/integration-testing-configuration/${integrationTestingConfigurationId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getInternalIntegrationTestingConfigurationRetrieveQueryKey = (integrationTestingConfigurationId: string,) => {
    return [`/integration-testing-configuration/${integrationTestingConfigurationId}/`] as const;
    }

    
export const getInternalIntegrationTestingConfigurationRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingConfigurationRetrieve>>, TError = unknown>(integrationTestingConfigurationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingConfigurationRetrieveQueryKey(integrationTestingConfigurationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationRetrieve>>> = ({ signal }) => internalIntegrationTestingConfigurationRetrieve(integrationTestingConfigurationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(integrationTestingConfigurationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingConfigurationRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationRetrieve>>>
export type InternalIntegrationTestingConfigurationRetrieveQueryError = unknown

export const useInternalIntegrationTestingConfigurationRetrieve = <TData = Awaited<ReturnType<typeof internalIntegrationTestingConfigurationRetrieve>>, TError = unknown>(
 integrationTestingConfigurationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingConfigurationRetrieveQueryOptions(integrationTestingConfigurationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getInternalIntegrationTestingConfigurationRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof internalIntegrationTestingConfigurationRetrieve>>, TError = unknown>(integrationTestingConfigurationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInternalIntegrationTestingConfigurationRetrieveQueryKey(integrationTestingConfigurationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationRetrieve>>> = ({ signal }) => internalIntegrationTestingConfigurationRetrieve(integrationTestingConfigurationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(integrationTestingConfigurationId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type InternalIntegrationTestingConfigurationRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationRetrieve>>>
export type InternalIntegrationTestingConfigurationRetrieveSuspenseQueryError = unknown

export const useInternalIntegrationTestingConfigurationRetrieveSuspense = <TData = Awaited<ReturnType<typeof internalIntegrationTestingConfigurationRetrieve>>, TError = unknown>(
 integrationTestingConfigurationId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getInternalIntegrationTestingConfigurationRetrieveSuspenseQueryOptions(integrationTestingConfigurationId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getInternalIntegrationTestingConfigurationRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ integrationTestingConfigurationId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { integrationTestingConfigurationId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (integrationTestingConfigurationId) {
            return appQueryClient.prefetchQuery({
              queryKey: getInternalIntegrationTestingConfigurationRetrieveQueryKey(integrationTestingConfigurationId),
              queryFn: () => internalIntegrationTestingConfigurationRetrieve(integrationTestingConfigurationId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Updates a specific integration testing configuration.
 */
export const internalIntegrationTestingConfigurationUpdate = (
    integrationTestingConfigurationId: string,
    integrationTestingConfigurationEditDataRequest: IntegrationTestingConfigurationEditDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<IntegrationTestingConfigurationReadData>(
      {url: `/integration-testing-configuration/${integrationTestingConfigurationId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: integrationTestingConfigurationEditDataRequest
    },
      options);
    }
  


export const getInternalIntegrationTestingConfigurationUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationUpdate>>, TError,{integrationTestingConfigurationId: string;data: IntegrationTestingConfigurationEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationUpdate>>, TError,{integrationTestingConfigurationId: string;data: IntegrationTestingConfigurationEditDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationUpdate>>, {integrationTestingConfigurationId: string;data: IntegrationTestingConfigurationEditDataRequest}> = (props) => {
          const {integrationTestingConfigurationId,data} = props ?? {};

          return  internalIntegrationTestingConfigurationUpdate(integrationTestingConfigurationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalIntegrationTestingConfigurationUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationUpdate>>>
    export type InternalIntegrationTestingConfigurationUpdateMutationBody = IntegrationTestingConfigurationEditDataRequest
    export type InternalIntegrationTestingConfigurationUpdateMutationError = unknown

    export const useInternalIntegrationTestingConfigurationUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalIntegrationTestingConfigurationUpdate>>, TError,{integrationTestingConfigurationId: string;data: IntegrationTestingConfigurationEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalIntegrationTestingConfigurationUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    